import { useQuery } from '@apollo/client/react'

import { graphql } from '~publish/graphql'

import { SyncIcon } from './SyncIcon'

import type { JSX } from 'react'

export const GetInsightsSyncStatus = graphql(/* GraphQL */ `
  query GetInsightsSyncStatus {
    account {
      id
      currentOrganization {
        id
        channels(input: { filter: { product: publish, isLocked: false } }) {
          id
          analytics {
            channelLastUpdatedAt
            postsLastUpdatedAt
          }
        }
      }
    }
  }
`)

/** The most recent of a set of timestamps, ignoring missing and unparseable ones. */
function newestOf(timestamps: Array<string | null | undefined>): string | null {
  let newest: string | null = null
  for (const timestamp of timestamps) {
    if (!timestamp) continue
    const time = new Date(timestamp).getTime()
    if (Number.isNaN(time)) continue
    if (newest === null || time > new Date(newest).getTime()) {
      newest = timestamp
    }
  }
  return newest
}

/**
 * Sync status across every channel. The page reports the most recent
 * collection rather than the oldest, matching how Home summarises the same
 * metrics.
 */
export const AllChannelsSyncIcon = (): JSX.Element | null => {
  const { data } = useQuery(GetInsightsSyncStatus)

  // Without data there is nothing to report, and a missing timestamp reads as
  // "recently", which would state a collection time the page does not know.
  if (!data) return null

  const channels = data.account?.currentOrganization?.channels ?? []

  return (
    <SyncIcon
      postsLastUpdatedAt={newestOf(
        channels.map((channel) => channel.analytics?.postsLastUpdatedAt),
      )}
      channelLastUpdatedAt={newestOf(
        channels.map((channel) => channel.analytics?.channelLastUpdatedAt),
      )}
    />
  )
}
